var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "col float-right" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-update-btn", {
                attrs: {
                  name: "updateBtn",
                  data: _vm.param.planUpdateBtnData,
                  btnEditable: _vm.btnEditable,
                  flagCondition: _vm.flagCondition,
                },
                on: { back: _vm.back },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editable && !_vm.deleteDisabled && _vm.isOld,
                    expression: "editable && !deleteDisabled && isOld",
                  },
                ],
                attrs: { label: "LBLREMOVE", icon: "remove" },
                on: { btnClicked: _vm.removePlan },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.editable &&
                      _vm.isOld &&
                      !_vm.disabled &&
                      !_vm.techCheck,
                    expression: "editable && isOld && !disabled && !techCheck",
                  },
                ],
                attrs: { label: "LBL0001043", icon: "autorenew" },
                on: { btnClicked: _vm.reCheckRisk },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editable && !_vm.disabled,
                    expression: "editable && !disabled",
                  },
                ],
                attrs: {
                  isSubmit: _vm.isComplete,
                  url: _vm.completeUrl,
                  param: _vm.assessPlan,
                  mappingType: "PUT",
                  label: "LBLCOMPLETE",
                  icon: "check",
                },
                on: {
                  beforeAction: _vm.completePlan,
                  btnCallback: _vm.completePlanCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-tab", {
        attrs: {
          type: "vertical",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    assessPlan: _vm.assessPlan,
                    attachInfo: _vm.attachInfo,
                    searchFlag: _vm.searchFlag,
                    vendorFlag: _vm.param.vendorFlag,
                    updateBtnData: _vm.param.planUpdateBtnData,
                  },
                  on: {
                    "update:assessPlan": function ($event) {
                      _vm.assessPlan = $event
                    },
                    "update:assess-plan": function ($event) {
                      _vm.assessPlan = $event
                    },
                    "update:attachInfo": function ($event) {
                      _vm.attachInfo = $event
                    },
                    "update:attach-info": function ($event) {
                      _vm.attachInfo = $event
                    },
                    "update:searchFlag": function ($event) {
                      _vm.searchFlag = $event
                    },
                    "update:search-flag": function ($event) {
                      _vm.searchFlag = $event
                    },
                    "update:updateBtnData": function ($event) {
                      return _vm.$set(_vm.param, "planUpdateBtnData", $event)
                    },
                    "update:update-btn-data": function ($event) {
                      return _vm.$set(_vm.param, "planUpdateBtnData", $event)
                    },
                    loadAssess: _vm.loadAssess,
                    saveCallback: _vm.saveCallback,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }